export default "__VITE_ASSET__DjOC4Pzi__"